import CONFIG from '../config';

import { Injectable } from '@angular/core';
import { Location } from '@angular/common';
import { Headers, RequestOptions } from '@angular/http';


import { AuthService } from './auth.service';
import { BackendService } from './backend.service';

import { Observable } from 'rxjs/Observable';
import { Subscription } from 'rxjs/Subscription';
import { NotificationService } from '../notification.service';




@Injectable()
export class Utilities {
    countries: Array<Object> = [];
    currencies: Array<Object> = [];
    products: Array<Object> = [];

    /*
    AOT doesn't like stray props on elements.  
    Our inputs depend on 'focused' and 'item' propertys that do not natively exist.  
    Adding here to comply
    */
    public focused;
    public item;

    constructor(
        public location: Location,
        public notificationService: NotificationService,
        public authService: AuthService,
        public backendService: BackendService
    ) {}

    //display server error- if due to jwt expiration, log out and redirect to login screen
    serverErrorOrTimeout(error: string): void {
        this.notificationService.showNotification({ timer: 5000, message: error, type: 'error', closeable: false });

        //if error is due to session time out, log the user out
        if(error === 'Session Expired- please log in') {
            this.authService.logout();
        }
    }

    //when sending jwt to server for data, check status (admin vs non admin, user key for profile, etc)
    checkLoginStatus(): Observable<any> {
        //return an observable so end function can subscribe and perform actions based on result after it comes in
        return this.backendService.getData(`${CONFIG.loginApiUrlBase}/checklogin`);
    }

    //specific test for auth guard- has to return an Observable<boolean> type
    checkLoginForAuthGuard(): Observable<boolean> {
        // if(sessionStorage.getItem('partial_login') === 'true') {
        //     this.notificationService.showNotification({ 
        //         timer: 5000, message: 'Please finish security process', 
        //         type: 'error', closeable: false 
        //     });
        //     return Observable.of(false)
        //         .do(() => {
        //             return this.authService.logout();
        //         });
        // } else {
            return this.backendService.getData(`${CONFIG.loginApiUrlBase}/checklogin`)
                .map(response => {
                    //update shared 'loggedIn' variable that maintains state while in app
                    this.authService.loggedIn = response['result'];
                    //update user_type variable that checks user's admin vs employee status
                    if(response) {
                        this.authService.LoginType = response['logintype'];
                        //this.authService.filterModulesForUserStatus(response['logintype']);
                    }
                    return response['result'];
                })
                .catch(error => {
                    return Observable.throw(this.serverErrorOrTimeout(error));
                });
        //}
    }

    //specific test for auth-admin guard- has to return an Observable<boolean> type
    checkLoginForAuthAdminGuard(): Observable<boolean> {
        return this.backendService.getData(`${CONFIG.loginApiUrlBase}/checklogin`)
            .map(response => {
                //update shared 'loggedIn' variable that maintains state while in app
                this.authService.loggedIn = response['result'];

                //update user_type variable that checks user's admin vs employee status
                if(response) {
                    this.authService.LoginType = response['logintype'];

                    //this is the admin auth guard, so if user is not admin, notify, return false, and redirect
                    if(response['logintype'] !== 'Admin') {
                        this.notificationService.showNotification({ 
                            closeable: true, timer: 0, message: 'Admin Access Only', type: 'error' 
                        });
                        this.location.go('/main');
                        return false;
                    }
                }
                return response['result'];
            })
            .catch(error => {
                return Observable.throw(this.serverErrorOrTimeout(error));
            });
    }

    //get basic db info for select lists used on multiple screens
    // getCountryList() {
    //     this.backendService.getData(CONFIG.countriesApiUrlBase)
    //         .subscribe(response => {
    //             const usa = response.find(country => {
    //                 return country.alpha_2_code === 'US';
    //             });
    //             this.countries = response.map(country => country)
    //                 .sort((a, b) => a.country_name >= b.country_name ? 1 : -1);
    //             this.countries.unshift(usa);
    //         });
    // }

    // getCurrenciesList() {
    //     this.backendService.getData(CONFIG.currenciesApiUrlBase)
    //         .subscribe(response => {
    //             this.currencies = response.map(currency => currency)
    //                 .sort((a, b) => a.currency_name >= b.currency_name ? 1 : -1);
    //         });
    // }

    // getProductList() {
    //     this.backendService.getData(CONFIG.productsApiUrlBase)
    //         .subscribe(response => {
    //             this.products = response.map(product => product);
    //         }, error => {
    //             console.error('server error:', error);
    //         });
    // }

    //all purpose cancel and return (if passed with nothing, just shows 'update canceled')
    cancel(msg='Update Canceled', type='warning'): void {
        this.location.back();
        this.notificationService.showNotification({ 
            timer: 2000, 
            message: msg, 
            type: type
        });
    }

    // deleteItem(url, nextUrl) {
    //     this.checkLoginStatus()
    //         .subscribe(result => {
    //             this.backendService.deleteData(url)
    //                 .subscribe(response => {
    //                     if(response.result) {
    //                         this.location.back();
    //                         this.notificationService.showNotification({ 'message': response.msg, 'type': 'success' });
    //                     } else {
    //                         this.notificationService.showNotification({ 'message': response.msg, 'type': 'error' });
    //                     }
                        
    //                 },
    //                 error => {
    //                     this.serverErrorOrTimeout(error);
    //                 });
    //         },
    //         error => {
    //             this.serverErrorOrTimeout(error);
    //         });
    // }
}